import { store, store$ } from "@redux/store";
import { loadAuth0 } from "libraries/authLibrary";
import { filter, fromEvent, take } from "rxjs";
import { authenticationSlice, modalSlice } from '../redux/slices';
import { isAuthLibraryNotLoaded } from '../constants/auth0Constants';

const { actions: authenticationActions } = authenticationSlice;
const { actions: modalActions } = modalSlice;

// Dispatch the redux slices.
const onAuthLibraryLoaded = () => store.dispatch(authenticationActions.authLibraryLoaded());
const onAuthLibraryErrored = (value) => store.dispatch(authenticationActions.authLibraryErrored(value));
const openModal = () => store.dispatch(modalActions.onOpen());

// check if user is logged in
const isUserNotLogin = (state) => state?.userProfile?.isLogin === false;

// check if the target for the event is a sign-in component.
const isSignInElement = (event) => event?.target?.closest('[data-component="sign-in"]');

/**
 * @private
 * onOpenModal: open the authentication modal.
 *
 */
function onOpenModal(event) {
    event.preventDefault();
    loadAuth0(onAuthLibraryLoaded, onAuthLibraryErrored).then(openModal);
}

/**
 * @private
 * attachSignUpClick: method to attach when user is not loging and need to open auth0 modal.
 * 
 */
const attachSignUpClick = () => {
    // user event delegation listen to click on a sign-in component
    fromEvent(document.body, 'click').pipe(
        filter(isSignInElement),
        filter(Boolean)
    ).subscribe(onOpenModal);
}

store$.pipe(
    filter(isUserNotLogin),
    filter(isAuthLibraryNotLoaded),
    take(1))
    .subscribe(attachSignUpClick);

export default onOpenModal;